const requiredFields = ["name", "country", "city", "venue", "startDatetime", "ticketsUrl", "description"];
const optionalFields = ["state", "type"];

export function safeExternalUrl(value) {
    try {
        const url = new URL(value);
        return ["http:", "https:"].includes(url.protocol) ? url.href : "";
    } catch {
        return "";
    }
}

export function validateEvent(event) {
    if (!event || typeof event !== "object" || Array.isArray(event)) {
        throw new Error("Each event must be an object.");
    }
    for (const field of requiredFields) {
        if (typeof event[field] !== "string" || !event[field].trim()) {
            throw new Error(`Enter a valid ${field}.`);
        }
    }
    if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(event.startDatetime) || !Number.isFinite(Date.parse(event.startDatetime))) {
        throw new Error("Enter a valid ISO date and time for startDatetime.");
    }
    const [year, month, day] = event.startDatetime.slice(0, 10).split("-").map(Number);
    const calendarDate = new Date(0);
    calendarDate.setUTCFullYear(year, month - 1, day);
    if (calendarDate.getUTCFullYear() !== year || calendarDate.getUTCMonth() !== month - 1 || calendarDate.getUTCDate() !== day) {
        throw new Error("startDatetime must contain a real calendar date.");
    }
    if (!safeExternalUrl(event.ticketsUrl)) throw new Error("Tickets URL must use http or https.");
    for (const field of optionalFields) {
        if (event[field] != null && typeof event[field] !== "string") throw new Error(`${field} must be text.`);
    }
    // Import only supported editable columns; never accept IDs or server fields.
    return Object.fromEntries([...requiredFields, ...optionalFields]
        .filter(field => event[field] != null)
        .map(field => [field, event[field].trim()]));
}

export function parseEventImport(json) {
    const events = JSON.parse(json);
    if (!Array.isArray(events)) throw new Error("JSON must be an array of events.");
    return events.map((event, index) => {
        try { return validateEvent(event); }
        catch (error) { throw new Error(`Event ${index + 1}: ${error.message}`); }
    });
}
